import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  MatSnackBar,
  MatSnackBarRef,
  SimpleSnackBar,
} from '@angular/material/snack-bar';
import { ConfirmComponent } from '../common/confirm/confirm.component';
import { DialogComponent } from '../common/dialog/dialog.component';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private snackBar: MatSnackBar, private matDialog: MatDialog) {}

  notification(message: string) {
    this.snackBar.open(message, null, {
      panelClass: 'notification',
    });
  }

  warning(message: string): MatSnackBarRef<SimpleSnackBar> {
    return this.snackBar.open(message, null, {
      panelClass: 'warning',
    });
  }

  error(message: string) {
    this.snackBar.open(message, 'X', {
      panelClass: 'error',
      duration: 0,
    });
  }

  confirm(title: string, body: string, lowerBody?: string) {
    return this.matDialog.open(ConfirmComponent, {
      data: {
        title: title,
        body: body,
        lowerBody: lowerBody,
      },
    });
  }

  dialog(title: string, text: string, footer: string) {
    return this.matDialog.open(DialogComponent, {
      data: {
        title: title,
        body: text,
        footer: footer,
      },
    });
  }
}
